import { useLayoutEffect, useState } from 'react';
import { FRAME_BREAKPOINT, FRAME_SIZE } from '../constants/layout';

export const frameSizeFor = (width) => {
  if (width >= FRAME_BREAKPOINT.WIDE) return FRAME_SIZE.WIDE;
  if (width >= FRAME_BREAKPOINT.MEDIUM) return FRAME_SIZE.MEDIUM;
  return FRAME_SIZE.COMPACT;
};

const contentWidth = (node) => {
  const style = getComputedStyle(node);
  return node.getBoundingClientRect().width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
};

/**
 * Size class of the element's content box (sidebar open or closed), measured before paint
 * and kept in sync with a ResizeObserver. No container-type: fixed children stay viewport-bound.
 */
export default function useFrameSize(ref) {
  const [size, setSize] = useState(FRAME_SIZE.WIDE);
  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    setSize(frameSizeFor(contentWidth(node)));
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry]) => setSize(frameSizeFor(entry.contentRect.width)));
    observer.observe(node);
    return () => observer.disconnect();
  }, [ref]);
  return size;
}
